var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61104 5.99994H11.502V11.3199C11.502 12.2533 10.6292 12.9999 9.53832 12.9999H7.46559C6.37468 12.9999 5.50195 12.2533 5.50195 11.3199V5.99994H5.61104Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.502 17.4782V12.0521C20.502 10.3565 19.1686 8.99994 17.502 8.99994C15.8353 8.99994 14.502 10.3565 14.502 12.0521V18.9478C14.502 20.6434 13.1686 21.9999 11.502 21.9999C9.83529 21.9999 8.50195 20.6434 8.50195 18.9478V13.5217",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.99994H6.5V5.99994H10.5V1.99994Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCable);
export default __webpack_public_path__ + "static/media/cable.a04f5e6e48dd2d2626696b844e513275.svg";
export { ForwardRef as ReactComponent };